<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <b-dropdown text="Action" variant="primary" class="mr-1">
            <b-dropdown-item @click="edit">
              <i class="fa fa-pencil"></i>Edit
            </b-dropdown-item>
            <b-dropdown-item @click="printPDF">
              <i class="fa fa-print"></i>Print
            </b-dropdown-item>

            <b-dropdown-item @click="deleteConfirm" :disabled="!model.suratkey || (model.delivery_status)!=null">
              <i class="fa fa-trash"></i>Delete
            </b-dropdown-item>
            
            <b-dropdown-item @click="sendspConfirm" :disabled="!model.suratkey">
              <i class="fa fa-send"></i>Send
            </b-dropdown-item>
            <b-dropdown-item @click="returspConfirm" :disabled="!model.suratkey || (model.historykey==null) || (model.delivery_status)=='return'">
              <i class="fa fa-send fa-rotate-90"></i>Return
            </b-dropdown-item>
            <!-- to do : perlu disimpan follow-up terkait sp  -->
            <b-dropdown-item @click="followupConfirm" :disabled="!model.suratkey">
              <i class="fa fa-comments"></i>Follow Up
            </b-dropdown-item>
          </b-dropdown>
          <button class="btn btn-primary mr-1" @click="newSP">
            <i class="fa fa-file"></i> Tambahkan SP
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.no_agreement" placeholder="No Agreement"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.no_kontrak" placeholder="No Kontrak"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">Debitur</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.CustName" placeholder="Debitur Name"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">CIF</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.CustCode" placeholder="Debitur No. (CIF)"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">Branch</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.branch" placeholder="Branch"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">LDSK</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.LDSK" placeholder="LDSK"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">Tgl. Surat</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
                <b-input-group-prepend>
                  <span class="input-group-text">until</span>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

        </b-col>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label class="label-eko">Status Surat</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.statussp" :plain="true" :options="optStatusSurat" style="min-width:70px !important;"></b-form-select>
            <b-input-group-prepend>
              <label class="label-eko pt-2">Expired in (<=)</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.expired_in_days" type="number" min="0"></b-form-input>
            <b-input-group-append>
              <b-input-group-text style="    height: 35px;">
                Days
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
                  <label class="label-eko">NO SP</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.nosurat" placeholder="No. SP"></b-form-input>
            <b-input-group-prepend>
              <label class="label-eko">Jenis Surat</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.jenissuratkey" :plain="true" :options="optJenisSurat"></b-form-select>
            
            <!-- <b-input-group-prepend>
              <span class="ml-2 pt-2">Kolektabilitas&nbsp;</span>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.kolektibiltas" :plain="true" :options="kolStatus"></b-form-select> -->
          </b-input-group>
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-eko">Issued by</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.createby" placeholder="Issued by"></b-form-input>
                <b-input-group-prepend>
                  <label class="label-eko">Collector</label>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.collector_id" :plain="true" :options="collectors"></b-form-select> 
              </b-input-group>
            </b-col>
            <b-col lg="12">
              <b-input-group>
                
                <b-input-group-prepend>
                  <label class="label-eko">Delivery Status</label>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.delivery_status" :plain="true" :options="optDeliveryStatus" style="min-width:70px !important;"></b-form-select>

                <b-input-group-prepend>
                  <label>Last Payment Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgllast1" type="date"></b-form-input>
                <b-input-group-prepend>
                  <span class="input-group-text">until</span>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgllast2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <div class="text-right mb-2 mt-1">
            <b-button variant="success" size="sm" @click="refresh()" class="ml-3">
              <i class="fa fa-refresh"></i> Apply Filter
            </b-button>
            <b-button
              variant="secondary"
              size="sm"
              class="ml-2"
              @click="clearFilter()"
            >Clear Filter</b-button>
          </div>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        :busy="isBusy"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(index)="data">{{ data.index+1 }}</template>
        <template v-slot:cell(debitur_name)="data">{{ data.item.CustCode}} | {{data.item.CustName}}</template>
        <template
          v-slot:cell(tglperhitungan)="data"
        >{{ data.item.tglperhitungan | moment("DD MMM YYYY") }}</template>
        <template
          v-slot:cell(duedate)="data"
        >{{ data.item.duedate | moment("DD MMM YYYY") }}</template>
        <template
          v-slot:cell(tglsurat)="data"
        >{{ data.item.tglsurat | moment("DD MMM YYYY") }}</template>
         <template
          v-slot:cell(expiredate)="data"
        >{{ data.item.expiredate | moment("DD MMM YYYY") }}</template>
        <template
          v-slot:cell(sp_last_payment_date)="data"
        > <span v-if="(data.item.sp_last_payment_date||'')!=''">
        {{ data.item.sp_last_payment_date | moment("DD MMM YYYY") }}
          </span><span v-else>-</span>
        </template>
        <template v-slot:cell(sp_payment)="data">{{ data.item.sp_payment | numFormat('0,0.00') }}</template>
        <template v-slot:cell(tunggakanpokok)="data">{{ data.item.tunggakanpokok | numFormat('0,0.00') }}</template>
        <template v-slot:cell(tunggakandenda)="data">{{ data.item.tunggakandenda | numFormat('0,0.00') }}</template>
        <template v-slot:cell(tunggakanbunga)="data">{{ data.item.tunggakanbunga | numFormat('0,0.00') }}</template>
        <template v-slot:cell(tunggakantotal)="data">{{ data.item.tunggakantotal | numFormat('0,0.00') }}</template>
        <template v-slot:cell(modified_by)="data">{{ data.item.modified_by ? data.item.modified_by : '-'}}</template>
        <template v-slot:cell(status)="data">
          <span v-if="(data.item.statussp||'')!=''">{{data.item.statussp}}</span>
          <span class="bg-danger p-1" v-else-if="data.item.dod_sp>0" v-b-tooltip.hover title="Terhitung dari tanggal surat.">Expired</span>
          <span v-else>
            <span class="bg-warning p-1" v-if="data.item.expired_in_days<8" v-b-tooltip.hover title="Terhitung dari tanggal surat."> Expired in {{data.item.expired_in_days}} days</span>
          </span>
        </template>

        <template v-slot:cell(delivery_status)="data">
          <div v-if="(data.item.delivery_status!=null)">
            <span v-if="data.item.delivery_status=='return'">
              Diretur pada {{data.item.returndate | moment('YYYY-MM-DD')}}
            </span>
            <span v-else>
              Dikirim pada {{data.item.deliverydate | moment('YYYY-MM-DD')}}
            </span>
          </div>
        </template>
        <template v-slot:cell(delivery_info)="data">
          <div v-if="(data.item.noresi||'')!=''">
            {{(data.item.jasapengiriman).toUpperCase()}} | No. Resi : {{data.item.noresi}}
          </div>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width:80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

    <b-modal v-model="showSendConfirm" header-bg-variant="primary"  title="Send Surat Peringatan Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col md="6">
                  <b-input-group>
                      <b-input-group-prepend><label style="width:140px;">Nomor Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.nosurat" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Tanggal Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.tglsurat_frmt" readonly></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="6">
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">Jenis Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.namasurat"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <!-- <b-col md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">Jenis Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.namasurat"  readonly></b-form-input>
                  </b-input-group>
              </b-col> -->
          </b-row >
          
          <b-row>
              <b-col md="6">
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">No. Aggrement</label></b-input-group-prepend>
                      <b-form-input v-model="model.no_agreement"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">No. Kontrak</label></b-input-group-prepend>
                      <b-form-input v-model="model.no_kontrak"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
          </b-row >
           <b-row>
              <b-col md="6">
                  <b-input-group >
              <b-input-group-prepend><label style="width:140px;">Debitur No (CIF)</label></b-input-group-prepend>
              <b-form-input v-model="model.CustCode"  readonly></b-form-input>
          </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group >
              <b-input-group-prepend><label style="width:140px;">Nama Debitur</label></b-input-group-prepend>
              <b-form-input v-model="model.CustName"  readonly></b-form-input>
          </b-input-group>
              </b-col>
          </b-row >
          <hr />
          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Tanggal Pengiriman</label>
                  </b-input-group-prepend>
                  <b-input type="date" v-model="sendspdt.tglkirim" :state="!$v.sendspdt.tglkirim.$error" />
                </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Tipe Pengiriman</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="sendspdt.tipepengiriman"
                    :state="!$v.sendspdt.tipepengiriman.$error"
                    :options="optTipePengiriman"
                  ></b-form-select>
                </b-input-group>
              </b-col>
          </b-row >
          <b-row v-if="ifInternal">
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Nama Pengirim</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="sendspdt.namapengirim"></b-form-input>
                </b-input-group>
              </b-col>
          </b-row >
          <b-row v-if="!ifInternal">
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">No. Resi</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="sendspdt.noresi"></b-form-input>
                </b-input-group>
              </b-col>
          </b-row >
          <hr />
          <b-row class="justify-content-center mt-1" >
              <b-button variant="primary" @click="sendsp"><i class="fa fa-paper-plane"></i> Send</b-button>
              <b-button variant="secondary" class="ml-1" @click="showSendConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
          </b-row>
      </b-modal>


      <b-modal v-model="showReturConfirm" header-bg-variant="primary"  title="Retur Surat Peringatan Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col md="6">
                  <b-input-group>
                      <b-input-group-prepend><label style="width:140px;">Nomor Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.nosurat" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Tanggal Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.tglsurat_frmt" readonly></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="6">
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">Jenis Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.namasurat"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <!-- <b-col md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">Jenis Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.namasurat"  readonly></b-form-input>
                  </b-input-group>
              </b-col> -->
          </b-row >
          
          <b-row>
              <b-col md="6">
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">No. Aggrement</label></b-input-group-prepend>
                      <b-form-input v-model="model.no_agreement"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">No. Kontrak</label></b-input-group-prepend>
                      <b-form-input v-model="model.no_kontrak"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
          </b-row >
           <b-row>
              <b-col md="6">
                  <b-input-group >
              <b-input-group-prepend><label style="width:140px;">Debitur No (CIF)</label></b-input-group-prepend>
              <b-form-input v-model="model.CustCode"  readonly></b-form-input>
          </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group >
              <b-input-group-prepend><label style="width:140px;">Nama Debitur</label></b-input-group-prepend>
              <b-form-input v-model="model.CustName"  readonly></b-form-input>
          </b-input-group>
              </b-col>
          </b-row >
          <hr />
          <h4>Data Pengiriman </h4>
          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Tgl Kirim</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.deliverydate_frmt" readonly class="form-control-static"></b-form-input>
                </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Jenis Pengiriman</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="model.jasapengiriman"
                    :state="!$v.model.tipepengiriman.$error"
                    :options="optTipePengiriman"
                    disabled
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col md="5" v-if="model.jasapengiriman == 'internal'">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Nama Pengirim</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.dikirimoleh" disabled></b-form-input>
                </b-input-group>
              </b-col>
              <b-col md="5" v-else>
                  <b-input-group>
                    <b-input-group-prepend>
                      <label style="width:140px;">No. Resi</label>
                    </b-input-group-prepend>
                    <b-form-input v-model="model.noresi" readonly class="form-control-static"></b-form-input>
                  </b-input-group>
              </b-col>
          </b-row >
          <b-row >
              
          </b-row >
          <hr>
          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Tanggal Retur</label>
                  </b-input-group-prepend>
                  <b-input type="date" v-model="returspdt.tglretur" :state="!$v.returspdt.tglretur.$error" />
                </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Alasan Retur</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="returspdt.alasanretur"
                    :state="!$v.returspdt.alasanretur.$error"
                    :options="optAlasanRetur"
                  ></b-form-select>
                </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="12">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Keterangan</label>
                  </b-input-group-prepend>
                  <b-form-textarea
                    id="textarea"
                    v-model="returspdt.description"
                    :state="!$v.returspdt.description.$error"
                    placeholder="Tambahkan keterangan.."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </b-input-group>
              </b-col>
          </b-row >
          <b-input-group>
            <b-input-group-prepend>
              <label style="width:140px;">Update ALamat</label>
            </b-input-group-prepend>
            <b-form-checkbox
                id="checkbox-1"
                v-model="returspdt.isupdateaddress"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                class="mt-2"
              >
              Update alamat debitur
            </b-form-checkbox>
          </b-input-group>
          <div v-if="returspdt.isupdateaddress==1">
               <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 200px">
                    Alamat Tinggal
                  </label>
                </b-input-group-prepend>
                <b-form-input v-model="returspdt.alamat" placeholder></b-form-input><br>
                <b-input-group-append class="p-2">
                  <label>RT/RW</label>
                </b-input-group-append>
                <b-form-input v-model="returspdt.rt" placeholder style="max-width:100px !important;"></b-form-input>
                <b-input-group-append style="height:35px;" is-text>/</b-input-group-append>
                <b-form-input v-model="returspdt.rw" placeholder style="max-width:100px !important;"></b-form-input>

              </b-input-group>
              <b-input-group class="sub-section-input">
                <b-input-group-prepend>
                  <label class="sub-section-label">Kelurahan</label>
                </b-input-group-prepend>
                <b-form-input placeholder v-model="returspdt.kelurahan"></b-form-input>
                <b-input-group-prepend>
                  <label class="sub-section-label text-right mr-2">Kecamatan</label>
                </b-input-group-prepend>
                <b-form-input placeholder v-model="returspdt.kecamatan"></b-form-input>
              </b-input-group>
              <b-input-group class="sub-section-input">
                <b-input-group-prepend>
                  <label class="sub-section-label">Kota</label>
                </b-input-group-prepend>
                <b-form-input placeholder v-model="returspdt.kota"></b-form-input>
                <b-input-group-prepend>
                  <label class="sub-section-label text-right mr-2">Propinsi</label>
                </b-input-group-prepend>
                <b-form-input placeholder v-model="returspdt.provinsi"></b-form-input>
              </b-input-group>
              <b-input-group
                class="sub-section-input"
                style="width: calc(50% - 103px)"
              >
                <b-input-group-prepend>
                  <label class="sub-section-label">Kodepos</label>
                </b-input-group-prepend>
                <b-form-input placeholde v-model="returspdt.kodepos" r></b-form-input>
              </b-input-group>
          </div>
           

          <hr />
          <b-row class="justify-content-center mt-1" >
              <b-button variant="primary" @click="retursp"><i class="fa fa-paper-plane"></i> Retur</b-button>
              <b-button variant="secondary" class="ml-1" @click="showReturConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
          </b-row>
      </b-modal>

      <b-modal v-model="showFollowUpConfirm" header-bg-variant="primary"  title="Follow Up Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col md="6">
                  <b-input-group>
                      <b-input-group-prepend><label style="width:140px;">Nomor Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.nosurat" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Tanggal Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.tglsurat_frmt" readonly></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="6">
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">Jenis Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.namasurat"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <!-- <b-col md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">Jenis Surat</label></b-input-group-prepend>
                      <b-form-input v-model="model.namasurat"  readonly></b-form-input>
                  </b-input-group>
              </b-col> -->
          </b-row >
          
          <b-row>
              <b-col md="6">
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">No. Aggrement</label></b-input-group-prepend>
                      <b-form-input v-model="model.no_agreement"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label style="width:140px;">No. Kontrak</label></b-input-group-prepend>
                      <b-form-input v-model="model.no_kontrak"  readonly></b-form-input>
                  </b-input-group>
              </b-col>
          </b-row >
           <b-row>
              <b-col md="6">
                  <b-input-group >
              <b-input-group-prepend><label style="width:140px;">Debitur No (CIF)</label></b-input-group-prepend>
              <b-form-input v-model="model.CustCode"  readonly></b-form-input>
          </b-input-group>
              </b-col>
              <b-col md="6">                            
                  <b-input-group >
              <b-input-group-prepend><label style="width:140px;">Nama Debitur</label></b-input-group-prepend>
              <b-form-input v-model="model.CustName"  readonly></b-form-input>
          </b-input-group>
              </b-col>
          </b-row >
          <hr />
          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Tanggal</label>
                  </b-input-group-prepend>
                  <b-input type="date" v-model="followupspdt.post_date" 
                  :state="!$v.followupspdt.post_date.$error" />
                </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="12">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Keterangan</label>
                  </b-input-group-prepend>
                  <b-form-textarea
                    id="textarea"
                    v-model="followupspdt.activity_update"
                    :state="!$v.followupspdt.activity_update.$error"
                    placeholder="Tambahkan keterangan.."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </b-input-group>
              </b-col>
          </b-row >
          <hr />
          <b-row class="justify-content-center mt-1" >
              <b-button variant="primary" @click="followupsp"><i class="fa fa-save"></i> Save</b-button>
              <b-button variant="secondary" class="ml-1" @click="showFollowUpConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
          </b-row>
      </b-modal>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>

  </div>
</template>
<style scoped>
  .label-eko{
    max-width: 100px;
  }
</style>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import invout from "../../apis/logistic_inv_out";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import pelunasan from "../../apis/pelunasanpinjaman";
import suratperingatan from "../../apis/suratperingatan";
import crud from "../../apis/crud";
// import Terbilang from 'terbilang-ts';
import terbilang from 'terbilang-spelling';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();
export default {
  components: { Loading },
  mixins: [validationMixin],
  validations: {
    model: {
      tipepengiriman: { required },
      tglkirim: { required },
      tglretur: { required },
      alasanretur: { required },
    },
    sendspdt:{
      tipepengiriman: { required },
      tglkirim: { required },
    },
    returspdt:{
        tglretur: { required },
        alasanretur: { required },
        description: { required }
      },
    followupspdt:{
        post_date: { required },
        activity_update: { required }
      },
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      // start print
      isLoading: false,
      showReport: false,
      reportUrl: "",
      // end print
      showSendConfirm: false,
      showReturConfirm: false,
      showFollowUpConfirm:false,
      showDelConfirm: false,
      model: {
        tipepengiriman: "",delivery_status:''
      },
      sendspdt:{
        tglkirim:'',tipepengiriman:'',namapengirim:'',noresi:''
      },
      returspdt:{
        tglretur:'',alasanretur:'',description:'',isupdateaddress:'0',nasabahkey:'',
        alamat:'',
        rt:'',
        rw:'',
        kelurahan:'',
        kecamatan:'',
        kota:'',provinsi:'',
        kodepos:'',
      },
      followupspdt:{
        post_date: '',
        activity_update: ''
      },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:moment().startOf('month').format('YYYY-MM-DD'),
        tgl2:moment().endOf('month').format('YYYY-MM-DD'),
        sortBy: "tglsurat",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        kolektibiltas: "",
        jenissuratkey: null,
        status:'',CustCode:'',CustName:'',createby:'',nosurat:'',
        no_kontrak:'',no_agreement:'',expired_in_days:'',
        branch:'', LDSK:'',statussp:'',delivery_status:''
      },
      collectors: [{ value: "", text: "-- ALL --" }],
      modelkredit: [
        { value: "", text: "-- ALL --" },
        { value: "PAB", text: "Angsuran Bulanan" },
        { value: "PRK", text: "Rekening Koran" },
      ],
      kolStatus: [
        { value: "", text: "-- ALL --" },
        { value: "KOL1", text: "KOL-1" },
        { value: "KOL2", text: "KOL-2" },
        { value: "KOL3", text: "KOL-3" },
        { value: "KOL4", text: "KOL-4" },
        { value: "KOL5", text: "KOL-5" },
      ],
      statuses: [
        { value: "", text: "-- ALL --" },
        { value: "secure", text: "Perform(Secure)" },
        { value: "unsecure", text: "Non Perform" },
      ],
      optStatusSurat:[
        { value: "", text: "-- ALL --" },
        { value: "gugur", text: "Gugur" },
        { value: "lancar", text: "Lancar" },
        { value: "expired", text: "Expired" },
      ],
      optDeliveryStatus:[
        { value: "", text: "-- ALL --" },
        { value: "send", text: "Send" },
        { value: "return", text: "Return" },
      ],
      optJenisSurat: [
        {
          value: null,
          text: "-- Please select an option --",
          disabled: true,
        },
      ],
      optTipePengiriman: [
        { value: "", text: "-- SELECT ONE --" },
        { value: "internal", text: "Internal" },
        // { value: "jasakirim", text: "Jasa Pengiriman" },
        { value: "jne", text: "JNE" },
        { value: "tiki", text: "TIKI" },
        { value: "pos", text: "POS Indonesia" },
        { value: "wahana", text: "Wahana" },
        { value: "jnt", text: "J & T Express" },
        { value: "sicepat", text: "Sicepat Express" },
        { value: "rpx", text: "RPX Express" },
      ],
      optAlasanRetur: [
        { value: "", text: "-- SELECT ONE --" },
        { value: "addressnotcomplete", text: "Alamat Tidak Lengkap" },
        { value: "nomatch", text: "Tidak Sesuai" },
        { value: "notfound", text: "Tidak Ketemu" },
        { value: "changeaddress", text: "Pindah Alamat" },
        { value: "broken", text: "Rusak" },
      ],
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidSendSP() {
      this.$v.sendspdt.$touch();
      return this.$v.sendspdt.$invalid;
    },
    invalidReturSP() {
      this.$v.returspdt.$touch();
      return this.$v.returspdt.$invalid;
    },
    invalidFollowupsp() {
      this.$v.followupspdt.$touch();
      return this.$v.followupspdt.$invalid;
    },
    ifInternal() {
      return this.sendspdt.tipepengiriman == "internal" ? true : false;
    },
    tblFields() {
      const fields = [
        {
          key: "nosurat",
          label: "No. SP",
          thStyle: "width:90px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "tglsurat",
          label: "Tgl. SP",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
         {
          key: "expiredate",
          label: "Tgl Jt. Tempo SP",
          thClass: "text-center",
           thStyle: "width:170px",
          sortable: true,
        },
        {
          key: "no_agreement",
          label: "No. Agreement",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "duedate",
          label: "Maturity Date",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "debitur_name",
          label: "Debitur",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "branch",
          label: "Branch",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
         {
          key: "LDSK",
          label: "LDSK",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "tglperhitungan",
          label: "Tgl. Perhitungan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "namasurat",
          label: "Jenis SP",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tunggakanpokok",
          label: "Tunggakan Pokok",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "tunggakandenda",
          label: "Tunggakan Denda",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "tunggakanbunga",
          label: "Tunggakan Bunga",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "tunggakantotal",
          label: "Tunggakan Total",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "sp_last_payment_date",
          label: "Last Payment Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "sp_payment",
          label: "Total Payment",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "delivery_status",
          label: "Delivery Status",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
        }, 
        {
          key: "delivery_info",
          label: "Delivery Info",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
        },      
        {
          key: "createby",
          label: "Diterbitkan Oleh",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "modified_by",
          label: "Modified by",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  async created() {
    if(this.$route.params.expired_in_days){
          this.tblData.expired_in_days = this.$route.params.expired_in_days;
          this.tblData.tgl1 = null;
          this.tblData.tgl2 = null;
        }
    // this.isBusy = true;
    // this.data();
    //this.note = replace(/\n/g, "<br />");
    const collSet = {
      tablename: "vwcollector",
      // page: 1,
      // limit: 20,
      // total: 0,
    };
    const collector = await crud.list(collSet);
    collector.map((dt) => {
      this.collectors.push({ value: dt.collector_id, text: dt.crewname });
    });

     const spDtset = {
      tablename: "surat-peringatan",
      page: 1,
      limit: 100,
      total: 0,
      sortBy: "nourut",
      sortDesc: "false",
    };
    const srtperingatan = await crud.list(spDtset);
    srtperingatan.map((item) => {
      this.optJenisSurat.push({
        value: item.jenissuratkey,
        text: item.namasurat,
      });
    });
 
  },
  methods: {
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }

      this.model = record;
      this.model.tglsurat_frmt = moment(record.tglsurat_frmt).format('YYYY-MM-DD')
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      try {
        
        const list = await suratperingatan.list(this.tblData);
        console.log('list',list);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        console.log(this.tblData);
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.CustCode = "";
      this.tblData.CustName = "";
      this.tblData.collectability = "";
      this.tblData.kolektibiltas = "";
      this.tblData.collector_id = "";
      this.tblData.model_pinjaman = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.tgllast1 = "";
      this.tblData.tgllast2 = "";
      this.tblData.no_kontrak = "";
      this.tblData.no_agreement = "";
      this.tblData.jenissuratkey=null;
      this.tblData.nosurat = "";
      this.tblData.status = "";
      this.tblData.statussp = "";
      this.tblData.delivery_status = "";
      this.tblData.expired_in_days = "";
      this.tblData.createby = null;
      this.tblData.collector_id = '';
      this.tblData.branch = '';
      this.tblData.LDSK = '';
      this.refresh();
    },
    async exportxls() {
      try {
        await suratperingatan.exportxls(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async printPDF() {
      if (this.model.suratkey) {
        this.isLoading = true;
        //console.log("#this.model.suratkey: ", this.model.suratkey);
        //console.log("#this.model.pinjamankey: ", this.model.pinjamankey);
        try {
          this.reportUrl = await suratperingatan.printPDF(this.model);
          this.isLoading = false;
          this.showReport = true;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message, "ERROR", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to print");
      }
    },
    async edit() {
      if (this.model.suratkey) {
        router.push({
          name: "loan.suratperingatan",
          params: { suratkey: this.model.suratkey },
        });
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },
    
    deleteConfirm() {
        if (this.model.suratkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },

    deleteData: async function() {
      try {
        this.isLoading=true;
        const spdt = await suratperingatan.remove(this.model);
        toastr.success(`SP no. : ${spdt.nosurat} has been Deleted!`);
        this.refresh();
        this.isLoading=false;
      } catch (error) {
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
            this.refresh();
            this.isLoading=false;       
      }
    },

    newSP () {
      router.push({
          name: "loan.suratperingatan"});
    },
    close() {
      router.push("home");
    },
    async sendspConfirm(){
      if (this.model.suratkey) { 
        try {
          this.showSendConfirm = true;
        } catch (error) {
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        } 
        
      } else {
        toastr.warn('Please select a row that want to be send!');
      }
    },
    sendsp: async function(evt){
        evt.preventDefault()
        try {
            if(this.invalidSendSP){
              toastr.warn('Harap isi form dengan lengkap');
            }else{
              this.showSendConfirm = false;
              this.isLoading=true;
              this.sendspdt.suratkey=this.model.suratkey;
              this.sendspdt.historykey=this.model.historykey;
              const resp = await suratperingatan.sendsp(this.sendspdt);

              this.sendspdt={
                tglkirim:'',tipepengiriman:'',namapengirim:'',noresi:''
              };
              this.refresh();
              this.isLoading=false;
              if (resp.message) {
                  toastr.warn(resp.message,'warning',10000);
              }
            }
            
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
    async returspConfirm(){
      if (this.model.suratkey) { 
        try {
          this.showReturConfirm = true;
          this.model.deliverydate_frmt = (this.model.deliverydate||'')!=''?moment(this.model.deliverydate).format('YYYY-MM-DD'):'';
          this.model.deliverydate_frmt = (this.model.deliverydate||'')!=''?moment(this.model.deliverydate).format('YYYY-MM-DD'):'';
          this.returspdt.nasabahkey=this.model.nasabahkey||this.model.customer_id;
          this.returspdt.alamat= this.model.alamat; 
          this.returspdt.rt= this.model.rt;
          this.returspdt.rw= this.model.rw;
          this.returspdt.kelurahan= this.model.kelurahan;
          this.returspdt.kecamatan= this.model.kecamatan;
          this.returspdt.kota= this.model.kota;
          this.returspdt.provinsi= this.model.provinsi;
          this.returspdt.kodepos= this.model.kodepos;

        } catch (error) {
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        } 
      } else {
        toastr.warn('Please select a row that want to be send!');
      }
    },
    async retursp(){
        try {
          if(this.invalidReturSP){
            toastr.warn('Harap isi form dengan lengkap');
          }else{
            this.showReturConfirm = false;
            this.isLoading=true;
            this.returspdt.suratkey=this.model.suratkey;
            this.returspdt.historykey=this.model.historykey;
            const resp = await suratperingatan.retursp(this.returspdt);
            this.returspdt={
              tglretur:'',alasanretur:'',description:'',isupdateaddress:'0',nasabahkey:'',
              alamat:'',
              rt:'',
              rw:'',
              kelurahan:'',
              kecamatan:'',
              kota:'',provinsi:'',
              kodepos:'',
            };

            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
          }
            
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
    followupConfirm(){
      if (this.model.suratkey) { 
        try {
          this.showFollowUpConfirm = true;
        } catch (error) {
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        } 
      } else {
        toastr.warn('Please select a row that want to be send!');
      }
    },
     async followupsp(){
        try {
          if(this.invalidFollowupsp){
            toastr.warn('Harap isi form dengan lengkap');
          }else{
            this.showFollowUpConfirm = false;
            this.isLoading=true;
            this.followupspdt.suratkey=this.model.suratkey;
            this.followupspdt.nasabahkey=this.model.nasabahkey;
            this.followupspdt.pinjamankey=this.model.pinjamankey;

            const resp = await suratperingatan.followupsp(this.followupspdt);
            this.followupspdt={
              post_date:'',activity_update:''
            };

            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
          }
            
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
  },
};
</script>